/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
import _isString from 'lodash/isString';
import CryptoJSMD5 from 'crypto-js/md5';

var Encryption =
/** @class */
function () {
  function Encryption() {}

  Encryption.GUID = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  };

  Encryption.uniqueId = function () {
    return Encryption.MD5(Encryption.GUID());
  };

  Encryption.MD5 = function (params) {
    if (!_isString(params)) {
      params = JSON.stringify(params);
    }

    return CryptoJSMD5(params).toString();
  };

  return Encryption;
}();

export { Encryption };
//# sourceMappingURL=encryption.js.map
